<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  async created() {
    document.title = "Sign In";
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  background-color: #f1f2f3;
}
</style>
